import React, {
  Fragment, createContext, Children, Component,
} from 'react';
import {
  Router,
  Switch as RSwitch,
  Route,
  matchPath,
  Link,
} from 'react-router-dom';
import history from 'State/history';
import PropTypes from 'prop-types';

const FacetRouter = ({ children }) => (
  <Router history={history}>{children}</Router>
);

FacetRouter.propTypes = {
  children: PropTypes.node,
};

FacetRouter.defaultProps = {
  children: <Fragment />,
};

const ContextPages = createContext([]);

const Switch = (props) => {
  const { children } = props; // eslint-disable-line react/prop-types
  return <RSwitch {...props}>{children}</RSwitch>;
};

const NavigableSwitch = ({ children }) => {
  const pages = [];

  Children.forEach(
    children,
    ({
      props: {
        href, path, title, exact, strict, hidden,
      },
    }) => {
      if (path === undefined || hidden) return;
      const obj = { href, title, path };
      obj.matchResult = matchPath(window.location.href, {
        path,
        exact,
        strict,
      });
      obj.active = obj.matchResult !== null;
      pages.push(obj);
    },
  );

  return (
    <ContextPages.Provider value={pages}>
      <Switch>{children}</Switch>
    </ContextPages.Provider>
  );
};

NavigableSwitch.propTypes = RSwitch.propTypes;

class Redirector extends Component {
  componentDidMount() {
    const { to } = this.props;
    history.replace(to);
  }

  render() {
    return null;
  }
}

Redirector.propTypes = {
  to: PropTypes.string.isRequired,
};

const Failover = ({ to }) => <Route component={() => <Redirector to={to} />} />;

Failover.propTypes = {
  to: PropTypes.string.isRequired,
};

const match = (path, exact = false, strict = false) => matchPath(window.location.pathname, { path, exact, strict });

export {
  Route, Switch, NavigableSwitch, ContextPages, Link, Failover, match,
};

export default FacetRouter;
